export default __webpack_public_path__ + "1bfe6f9a5e2c8cc98caed217c70a5a38.svg";